import { en, pt } from "../text";
import { getLayout, getCountry, getProfession } from "../../register/api";

export const preventDoubleSubmit = (func, wait = 1000) => {
    let isSubmitting = false;
    
    return function (...args) {
        if (isSubmitting) {
            console.log('Submissão já em andamento, ignorando...');
            return;
        }
        
        isSubmitting = true;
        
        // Executa a função e aguarda sua conclusão
        const result = func.apply(this, args);
        
        // Se a função retorna uma Promise, aguarda ela finalizar
        if (result && typeof result.then === 'function') {
            result
                .finally(() => {
                    setTimeout(() => {
                        isSubmitting = false;
                    }, wait);
                });
        } else {
            // Para funções síncronas
            setTimeout(() => {
                isSubmitting = false;
            }, wait);
        }
        
        return result;
    };
};

export const getAll = async (context) => {
  const [getRenderData] = await Promise.all([
    getLayout(context.neoId),
    getCountry(context.neoId),
    getProfession(context.neoId),
  ]);

  if (!getRenderData.retorno) {
    context.setInvalidUrl(pt.slugError);
    return;
  }

  if(context.neoId === 'joyce') {
    getRenderData.dados.text = "#333";
  }

  context.setLayout(getRenderData.dados);

  if(getRenderData.dados.idioma === "ptbr") {
    context.setText(pt);
  }else{
    context.setText(en);
  }
};
